// import { FiGlobe, FiArrowDown } from "react-icons/fi";

// export default function Header() {
//   return (
//     <header className="relative overflow-hidden bg-gradient-to-br from-[#1a1a2e] via-[#2a2a3e] to-[#DA2128]/30 text-white">
//       <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(218,33,40,0.2),transparent_60%)]" />
//       <div className="absolute top-0 right-0 h-96 w-96 rounded-full bg-[#DB6400]/10 blur-3xl -mr-20 -mt-20" />
//       <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-10 py-24 md:py-32">
//         <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
//           <div className="max-w-3xl">
//             <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs md:text-sm font-medium text-white/90 backdrop-blur-md border border-white/10 mb-6">
//               <FiGlobe className="h-4 w-4" /> ASSOCHAM — Apex Chamber of Commerce
//             </div>
//             <h1 className="font-['Cormorant_Garamond'] text-6xl md:text-[6.5rem] font-bold leading-[0.9] tracking-tight mb-6">
//               International <br />
//               <span className="italic font-normal text-[#F59C00]">Division</span>
//             </h1>
//             <p className="text-lg md:text-xl text-white/80 font-light leading-relaxed max-w-2xl">
//               Connecting Indian industry to global markets through strategic partnerships, trade missions, policy advocacy, and institutional collaboration.
//             </p>
//           </div>
//           <div className="flex-shrink-0">
//             {/* <a href="#switch-nav" className="inline-flex items-center gap-2 rounded-full bg-[#DA2128] text-white px-6 py-3 font-semibold text-sm shadow-2xl shadow-[#DA2128]/30 hover:bg-[#DB2628] transition-colors border border-white/10">
//               Explore Sections <FiArrowDown className="h-4 w-4" />
//             </a> */}
//           </div>
//         </div>
//       </div>
//       <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-[#FAF7F2] to-transparent" />
//     </header>
//   );
// }







// new new code 




import { FiGlobe, FiArrowDown, FiZap, FiCheckCircle } from "react-icons/fi";
import { motion } from "framer-motion";

export default function Header() {
  return (
    <header className="relative overflow-hidden bg-gradient-to-br from-[#1a1a2e] via-[#2a2a3e] to-[#1a1a2e] text-white py-12 md:py-20 px-6 md:px-10 border-b border-gray-100/10">
      {/* Subtle Background Lighting & Ambient Orbs */}
      <div className="absolute top-0 right-0 h-80 w-80 rounded-full bg-[#DA2128]/15 blur-3xl -mr-16 -mt-16 pointer-events-none" />
      <div className="absolute bottom-0 left-10 h-60 w-60 rounded-full bg-[#DB6400]/15 blur-3xl pointer-events-none" />

      <div className="relative z-10 mx-auto max-w-7xl">
        <div className="grid lg:grid-cols-12 gap-8 items-center">
          
          {/* Main Hero Typography Column */}
          <motion.div 
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="lg:col-span-8 space-y-5"
          >
            {/* Top Pill Badge */}
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3.5 py-1 text-xs font-medium text-white/90 backdrop-blur-md border border-white/10 shadow-sm">
              <FiGlobe className="h-3.5 w-3.5 text-[#F59C00]" /> 
              <span>ASSOCHAM — Apex Chamber of Commerce</span>
            </div>

            {/* Controlled Header Sizes */}
            <h1 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl md:text-6xl font-bold leading-[1.05] tracking-tight">
              International <span className="italic font-normal text-[#F59C00]">Division</span>
            </h1>

            {/* Subtext with refined sizing */}
            <p className="text-sm md:text-base text-white/80 font-light leading-relaxed max-w-2xl">
              Connecting Indian industry to global markets through strategic partnerships, trade missions, policy advocacy, and institutional collaboration worldwide.
            </p>

            {/* Call to Actions */}
            {/* <div className="pt-2 flex flex-wrap items-center gap-3">
              <a
                href="#events"
                className="inline-flex items-center gap-2 rounded-xl bg-[#DA2128] hover:bg-[#DB2628] text-white px-5 py-2.5 font-semibold text-xs transition-all duration-200 shadow-md shadow-[#DA2128]/25"
              >
                Explore Divisions <FiArrowDown className="h-3.5 w-3.5" />
              </a>
              <a
                href="#tenders"
                className="inline-flex items-center gap-2 rounded-xl bg-white/10 hover:bg-white/15 text-white px-5 py-2.5 font-semibold text-xs transition-all duration-200 border border-white/10 backdrop-blur-sm"
              >
                Global Tenders <FiZap className="h-3.5 w-3.5 text-[#F59C00]" />
              </a>
            </div> */}
          </motion.div>

          {/* Quick Stats Floating Card Column */}
          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="lg:col-span-4 grid sm:grid-cols-2 lg:grid-cols-1 gap-3"
          >
            <div className="rounded-2xl bg-white/5 border border-white/10 p-4 backdrop-blur-md shadow-lg flex items-center gap-3.5">
              <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-[#DA2128] to-[#DB2628] flex items-center justify-center text-white shrink-0 font-bold text-base shadow-md">
                100+
              </div>
              <div>
                <div className="text-xs font-semibold text-white font-['Outfit']">Global Chamber Partners</div>
                <div className="text-[11px] text-white/60">Cross-border institutional MoUs</div>
              </div>
            </div>

            <div className="rounded-2xl bg-white/5 border border-white/10 p-4 backdrop-blur-md shadow-lg flex items-center gap-3.5">
              <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-[#DB6400] to-[#F59C00] flex items-center justify-center text-white shrink-0 font-bold text-base shadow-md">
                50+
              </div>
              <div>
                <div className="text-xs font-semibold text-white font-['Outfit']">Commercial Missions</div>
                <div className="text-[11px] text-white/60">Annual delegations & summits</div>
              </div>
            </div>
          </motion.div>

        </div>
      </div>
    </header>
  );
}